import React from 'react';
import { Link } from 'react-router-dom';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="layout">
      <h1>Privacy Policy for Vanshavali Maker</h1>
      <p>
        <strong>Effective Date:</strong> 15-Sep-2024 <br />
        <strong>Last Updated:</strong> 15-Sep-2024
      </p>

      <p>
        Welcome to <strong>Vanshavali Maker</strong> (the "Site"). Your privacy
        is of paramount importance to us. This Privacy Policy outlines how we
        collect, use, and protect your personal information in compliance with
        relevant privacy regulations, including the General Data Protection
        Regulation (GDPR) and the California Privacy Rights Act (CPRA).
      </p>

      <p>
        By using our Site, you consent to the terms outlined in this Privacy
        Policy.
      </p>

      <h2>1. Information We Collect</h2>
      <p>We collect the following types of information:</p>

      <h3>a. Personal Data</h3>
      <p>When you use our Site, we may collect personal data, such as:</p>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>IP address</li>
        <li>
          Other information you voluntarily provide to us through forms or
          sign-ups.
        </li>
      </ul>

      <h3>b. Non-Personal Data</h3>
      <p>We also collect non-personal data such as:</p>
      <ul>
        <li>Browser type</li>
        <li>Operating system</li>
        <li>Referring URLs</li>
        <li>Usage data and browsing activity</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <p>We may use your information for the following purposes:</p>
      <ul>
        <li>To provide and maintain our Site and services</li>
        <li>To communicate with you via email (e.g., updates, newsletters)</li>
        <li>To personalize your experience on our Site</li>
        <li>To monitor usage and improve the performance of the Site</li>
        <li>To comply with legal obligations</li>
      </ul>

      <h2>3. Legal Basis for Processing Personal Data (GDPR)</h2>
      <p>
        Under the GDPR, we process your personal data based on the following
        legal grounds:
      </p>
      <ul>
        <li>
          <strong>Consent:</strong> You have provided explicit consent for us to
          process your data for specific purposes.
        </li>
        <li>
          <strong>Contractual Necessity:</strong> Your data is processed to
          fulfill a contract with you, such as providing the services on our
          Site.
        </li>
        <li>
          <strong>Legal Obligations:</strong> We may process your data to comply
          with laws and regulations.
        </li>
      </ul>

      <h2>4. Your Privacy Rights (GDPR & CPRA)</h2>
      <p>You have the following rights under GDPR and CPRA:</p>

      <h3>a. GDPR Rights (For European Economic Area Residents)</h3>
      <ul>
        <li>
          <strong>Right to Access:</strong> You can request access to your
          personal data and obtain a copy of it.
        </li>
        <li>
          <strong>Right to Rectification:</strong> You can request corrections
          to any inaccurate or incomplete personal data.
        </li>
        <li>
          <strong>Right to Erasure:</strong> You can request the deletion of
          your personal data under certain circumstances.
        </li>
        <li>
          <strong>Right to Data Portability:</strong> You can request a copy of
          your data in a structured, commonly used format.
        </li>
        <li>
          <strong>Right to Object/Restrict Processing:</strong> You can object
          or request restrictions on certain data processing activities.
        </li>
      </ul>

      <h3>b. CPRA Rights (For California Residents)</h3>
      <ul>
        <li>
          <strong>Right to Know:</strong> You have the right to request details
          about the personal data we have collected about you over the past 12
          months.
        </li>
        <li>
          <strong>Right to Delete:</strong> You can request the deletion of your
          personal information, subject to certain legal exceptions.
        </li>
        <li>
          <strong>Right to Opt-Out of Sale/Sharing:</strong> You can request
          that your personal information not be sold or shared with third
          parties.
        </li>
        <li>
          <strong>Right to Non-Discrimination:</strong> You will not be
          discriminated against for exercising your privacy rights.
        </li>
      </ul>

      <p>
        To exercise any of these rights, please contact us at{' '}
        <Link href="mailto:humendrax@gmail.com">humendrax@gmail.com</Link>.
      </p>

      <h2>5. How We Share Your Information</h2>
      <p>
        We do not sell your personal information. However, we may share your
        information with:
      </p>
      <ul>
        <li>
          <strong>Service Providers:</strong> Third-party vendors who assist us
          in providing services (e.g., hosting, email services) under strict
          confidentiality agreements.
        </li>
        <li>
          <strong>Legal Authorities:</strong> When required by law or to protect
          the rights and safety of our users and third parties.
        </li>
      </ul>

      <h2>6. Data Retention</h2>
      <p>
        We will retain your personal data only for as long as necessary to
        fulfill the purposes for which it was collected or as required by
        applicable laws and regulations.
      </p>

      <h2>7. Data Security</h2>
      <p>
        We implement technical and organizational security measures to protect
        your personal data from unauthorized access, alteration, disclosure, or
        destruction. However, no online service is 100% secure, and we cannot
        guarantee absolute security.
      </p>

      <h2>8. Cookies and Tracking Technologies</h2>
      <p>
        We use cookies and similar tracking technologies to enhance your
        experience on our Site. You can manage your cookie preferences through
        your browser settings.
      </p>

      <h2>9. International Data Transfers</h2>
      <p>
        Your personal data may be transferred to and processed in countries
        outside of your residence, including the United States. We ensure that
        any such transfers are conducted in compliance with applicable privacy
        laws.
      </p>

      <h2>10. Children’s Privacy</h2>
      <p>
        Our Site is not intended for children under the age of 16. We do not
        knowingly collect personal data from children without parental consent.
        If we become aware that we have collected data from a child, we will
        take steps to delete it.
      </p>

      <h2>11. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page, and the "Last Updated" date will be revised
        accordingly.
      </p>

      <h2>12. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, or if
        you wish to exercise any of your privacy rights, please contact us at:
      </p>
      <p>
        <strong>Email:</strong>{' '}
        <a href="mailto:humendrax@gmail.com">humendrax@gmail.com</a>
        <br />
        <strong>Website:</strong>{' '}
        <Link to="/">https://vanshavali-maker.netlify.app/</Link>
      </p>

      <p>
        By continuing to use our Site, you acknowledge that you have read and
        understood this Privacy Policy.
      </p>
    </div>
  );
};

export default Privacy;
